import { render, staticRenderFns } from "./test-common.vue?vue&type=template&id=cc486ade&scoped=true&"
import script from "./test-common.vue?vue&type=script&lang=js&"
export * from "./test-common.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc486ade",
  null
  
)

export default component.exports